import { render } from "./ProTipRequests.vue?vue&type=template&id=79bf6ec9&scoped=true"
import script from "./ProTipRequests.vue?vue&type=script&lang=js"
export * from "./ProTipRequests.vue?vue&type=script&lang=js"

import "./ProTipRequests.vue?vue&type=style&index=0&id=79bf6ec9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bf6ec9"]])

export default __exports__